import { mixins, styled } from '@bob/library'

export const OpenWrapper = styled.div`
  text-align: center;
`

export const OpenURL = styled.a`
  ${mixins.cta.primary('blue')}
  margin-top: 40px;
`

export const Title = styled.h2`
  ${mixins.typography.headlineLarge}
  margin-bottom: 20px;
`
